import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/arrow-left-gray.svg'
import _imports_1 from '@/assets/arrow-left.svg'
import _imports_2 from '@/assets/arrow-right.svg'
import _imports_3 from '@/assets/arrow-right-gray.svg'
import _imports_4 from '@/assets/user-details.svg'
import _imports_5 from '@/assets/phone-icon.svg'
import _imports_6 from '@/assets/message-icon.svg'
import _imports_7 from '@/assets/navigation.svg'


const _hoisted_1 = { class: "w-full mb-3 flex flex-col lg:flex-row items-start gap-3 h-[285px]" }
const _hoisted_2 = { class: "w-full lg:w-[72%] h-full bg-white p-3 rounded-primary-radius shadow-[0px_1px_13px_rgba(57,56,64,0.1)] overflow-auto" }
const _hoisted_3 = { class: "flex items-center justify-between mb-2" }
const _hoisted_4 = { class: "text-xl text-primary-text-color tracking-[0.01rem] font-semibold" }
const _hoisted_5 = {
  key: 0,
  class: "flex items-start gap-2"
}
const _hoisted_6 = {
  src: _imports_0,
  alt: ""
}
const _hoisted_7 = {
  src: _imports_1,
  alt: ""
}
const _hoisted_8 = {
  src: _imports_2,
  alt: ""
}
const _hoisted_9 = {
  src: _imports_3,
  alt: ""
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  class: "flex flex-col lg:flex-row items-start gap-3"
}
const _hoisted_13 = { class: "flex-1 flex flex-col items-start gap-2" }
const _hoisted_14 = { class: "text-base leading-[20px] tracking-[0.01rem] text-primary-text-color font-normal pt-1" }
const _hoisted_15 = { class: "text-base leading-[20px] tracking-[0.01rem] text-primary-text-color font-normal pt-1" }
const _hoisted_16 = { class: "text-base leading-[20px] tracking-[0.01rem] text-primary-text-color font-normal pt-1" }
const _hoisted_17 = { class: "text-base leading-[20px] tracking-[0.01rem] text-primary-text-color font-normal pt-1" }
const _hoisted_18 = { class: "flex-1 flex flex-col items-start gap-2" }
const _hoisted_19 = { class: "text-base leading-[20px] tracking-[0.01rem] text-primary-text-color font-normal pt-1" }
const _hoisted_20 = { class: "text-base leading-[20px] tracking-[0.01rem] text-primary-text-color font-normal pt-1" }
const _hoisted_21 = { class: "text-base leading-[20px] tracking-[0.01rem] text-primary-text-color font-normal pt-1" }
const _hoisted_22 = { class: "text-base leading-[20px] tracking-[0.01rem] text-primary-text-color font-normal pt-1" }
const _hoisted_23 = { class: "w-[35%] h-[285px] bg-white p-3 rounded-primary-radius shadow-[0px_1px_13px_rgba(57,56,64,0.1)]" }
const _hoisted_24 = { class: "text-xl pb-4 text-primary-text-color tracking-[0.01rem] font-semibold" }
const _hoisted_25 = {
  key: 1,
  class: "flex flex-col items-start gap-4"
}
const _hoisted_26 = { class: "flex items-center gap-2 pb-2 border-b border-[#F1F0F5] w-full" }
const _hoisted_27 = { class: "text-base leading-[20px] tracking-[0.01rem] text-primary-text-color font-norma" }
const _hoisted_28 = { class: "flex items-center gap-2 pb-2 border-b border-[#F1F0F5] w-full" }
const _hoisted_29 = ["href"]
const _hoisted_30 = {
  key: 1,
  class: "text-base leading-[20px] tracking-[0.01rem] text-primary-text-color font-norma"
}
const _hoisted_31 = { class: "flex items-center gap-2 pb-2 border-b border-[#F1F0F5] w-full" }
const _hoisted_32 = ["href"]
const _hoisted_33 = {
  key: 1,
  class: "text-base leading-[20px] tracking-[0.01rem] text-primary-text-color font-norma"
}
const _hoisted_34 = { class: "flex items-center gap-2 pb-2 border-b border-[#F1F0F5] w-full" }
const _hoisted_35 = ["href"]
const _hoisted_36 = {
  key: 1,
  class: "text-base leading-[20px] tracking-[0.01rem] text-primary-text-color font-norma"
}

import { ref } from "vue";
import CardLoader from "@/components/Loaders/CardLoader.vue";
import TechnicalDetailsInputsBlock from "../Commercial/TechnicalDetailsInputsBlock.vue";
import TechnicalModal from "../Commercial/TechnicalModal.vue";
import { BauabschnittDetail } from "@/types";
import { useTranslate } from "@/composables/useTranslate";

type Props = {
  isLoading: boolean;
  projectId: string | null | undefined;
  vnb: string | null | undefined;
  wb: string | null | undefined;
  wechselrichter: string | null | undefined;
  speicher: string | null | undefined;
  masskonzept: string | null | undefined;
  numberOfModules: number | null | undefined;
  modulType: string | null | undefined;
  ibnDate: Date | null | undefined;
  homeOwnerName: string | null | undefined;
  homeOwnerAddress: string | null | undefined;
  homeOwnerPhone: string | null | undefined;
  emailAddress: string | null | undefined;
  bauabschnitt: number | null | undefined;
  strings: number | null | undefined;
  moduleFields: number | null | undefined;
  bauabschnittDetails: BauabschnittDetail[] | null | undefined;
};

type Emits = {
  (event: "refresh"): void;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'BasicDetails',
  props: {
    isLoading: { type: Boolean },
    projectId: {},
    vnb: {},
    wb: {},
    wechselrichter: {},
    speicher: {},
    masskonzept: {},
    numberOfModules: {},
    modulType: {},
    ibnDate: {},
    homeOwnerName: {},
    homeOwnerAddress: {},
    homeOwnerPhone: {},
    emailAddress: {},
    bauabschnitt: {},
    strings: {},
    moduleFields: {},
    bauabschnittDetails: {}
  },
  emits: ["refresh"],
  setup(__props: any) {

const props = __props;

const { t } = useTranslate();
const isTechnicalDetailsInput = ref(
  props.bauabschnitt && props.bauabschnitt > 0
);
const isTechnicalFormModal = ref(false);

const toggleTechnicalFormModal = () => {
  isTechnicalFormModal.value = !isTechnicalFormModal.value;
};

const selectedInput = ref();
const onSelectedInputHandler = (input: any) => {
  selectedInput.value = input;
  isTechnicalFormModal.value = true;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, { name: "nested" }, {
      default: _withCtx(() => [
        (isTechnicalFormModal.value)
          ? (_openBlock(), _createBlock(TechnicalModal, {
              key: 0,
              class: "modal",
              onToggleModal: toggleTechnicalFormModal,
              "selected-input": selectedInput.value,
              "project-id": props.projectId,
              onRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('refresh')))
            }, null, 8, ["selected-input", "project-id"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(t)("projects.technical_details")), 1),
          (__props.bauabschnitt && __props.bauabschnitt > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (isTechnicalDetailsInput.value = true)),
                  class: "w-6 h-6 flex items-center justify-center rounded-sm"
                }, [
                  _withDirectives(_createElementVNode("img", _hoisted_6, null, 512), [
                    [_vShow, isTechnicalDetailsInput.value]
                  ]),
                  _withDirectives(_createElementVNode("img", _hoisted_7, null, 512), [
                    [_vShow, !isTechnicalDetailsInput.value]
                  ])
                ]),
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (isTechnicalDetailsInput.value = false)),
                  class: "w-6 h-6 flex items-center justify-center cursor-pointer rounded-sm"
                }, [
                  _withDirectives(_createElementVNode("img", _hoisted_8, null, 512), [
                    [_vShow, isTechnicalDetailsInput.value]
                  ]),
                  _withDirectives(_createElementVNode("img", _hoisted_9, null, 512), [
                    [_vShow, !isTechnicalDetailsInput.value]
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        (__props.isLoading)
          ? (_openBlock(), _createBlock(CardLoader, { key: 0 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (isTechnicalDetailsInput.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(TechnicalDetailsInputsBlock, {
                      onOpenModal: onSelectedInputHandler,
                      strings: __props.strings,
                      "module-fields": __props.moduleFields,
                      bauabschnitt: __props.bauabschnitt,
                      "bauabschnitt-details": __props.bauabschnittDetails
                    }, null, 8, ["strings", "module-fields", "bauabschnitt", "bauabschnitt-details"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", null, [
                        _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "text-sm font-semibold text-[#898790] leading-[17px] tracking-[0.01rem]" }, " VNB ", -1)),
                        _createElementVNode("p", _hoisted_14, _toDisplayString(__props.vnb ? __props.vnb : "-"), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[4] || (_cache[4] = _createElementVNode("h4", { class: "text-sm font-semibold text-[#898790] leading-[17px] tracking-[0.01rem]" }, " Wechselrichter ", -1)),
                        _createElementVNode("p", _hoisted_15, _toDisplayString(__props.wechselrichter ? __props.wechselrichter : "-"), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[5] || (_cache[5] = _createElementVNode("h4", { class: "text-sm font-semibold text-[#898790] leading-[17px] tracking-[0.01rem]" }, " Speicher ", -1)),
                        _createElementVNode("p", _hoisted_16, _toDisplayString(__props.speicher ? __props.speicher : "-"), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[6] || (_cache[6] = _createElementVNode("h4", { class: "text-sm font-semibold text-[#898790] leading-[17px] tracking-[0.01rem]" }, " Masskonzept ", -1)),
                        _createElementVNode("p", _hoisted_17, _toDisplayString(__props.masskonzept ? __props.masskonzept : "-"), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", null, [
                        _cache[7] || (_cache[7] = _createElementVNode("h4", { class: "text-sm font-semibold text-[#898790] leading-[17px] tracking-[0.01rem]" }, " WB ", -1)),
                        _createElementVNode("p", _hoisted_19, _toDisplayString(__props.wb ? __props.wb : "-"), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[8] || (_cache[8] = _createElementVNode("h4", { class: "text-sm font-semibold text-[#898790] leading-[17px] tracking-[0.01rem]" }, " Number of Modules ", -1)),
                        _createElementVNode("p", _hoisted_20, _toDisplayString(__props.numberOfModules ? __props.numberOfModules : "-"), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[9] || (_cache[9] = _createElementVNode("h4", { class: "text-sm font-semibold text-[#898790] leading-[17px] tracking-[0.01rem]" }, " Modul Type ", -1)),
                        _createElementVNode("p", _hoisted_21, _toDisplayString(__props.modulType ? __props.modulType : "-"), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[10] || (_cache[10] = _createElementVNode("h4", { class: "text-sm font-semibold text-[#898790] leading-[17px] tracking-[0.01rem]" }, " IBN Date ", -1)),
                        _createElementVNode("p", _hoisted_22, _toDisplayString(__props.ibnDate ? new Date(__props.ibnDate).toLocaleDateString("de") : "-"), 1)
                      ])
                    ])
                  ]))
            ]))
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("h2", _hoisted_24, _toDisplayString(_unref(t)("projects.details")), 1),
        (__props.isLoading)
          ? (_openBlock(), _createBlock(CardLoader, { key: 0 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _cache[11] || (_cache[11] = _createElementVNode("img", {
                  class: "w-4 h-4",
                  src: _imports_4,
                  alt: "User icon"
                }, null, -1)),
                _createElementVNode("span", _hoisted_27, _toDisplayString(__props.homeOwnerName ? __props.homeOwnerName : "-"), 1)
              ]),
              _createElementVNode("div", _hoisted_28, [
                _cache[12] || (_cache[12] = _createElementVNode("img", {
                  class: "w-4 h-4",
                  src: _imports_5,
                  alt: "User icon"
                }, null, -1)),
                (__props.homeOwnerPhone)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: 'tel:' + __props.homeOwnerPhone,
                      class: "text-base leading-[20px] tracking-[0.01rem] text-primary-text-color font-norma"
                    }, _toDisplayString(__props.homeOwnerPhone), 9, _hoisted_29))
                  : (_openBlock(), _createElementBlock("span", _hoisted_30, "-"))
              ]),
              _createElementVNode("div", _hoisted_31, [
                _cache[13] || (_cache[13] = _createElementVNode("img", {
                  class: "w-4 h-4",
                  src: _imports_6,
                  alt: "User icon"
                }, null, -1)),
                (__props.emailAddress)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: 'mailto:' + __props.emailAddress,
                      class: "text-base leading-[20px] tracking-[0.01rem] text-primary-text-color font-norma"
                    }, _toDisplayString(__props.emailAddress), 9, _hoisted_32))
                  : (_openBlock(), _createElementBlock("span", _hoisted_33, "-"))
              ]),
              _createElementVNode("div", _hoisted_34, [
                _cache[14] || (_cache[14] = _createElementVNode("img", {
                  class: "w-4 h-4",
                  src: _imports_7,
                  alt: "User icon"
                }, null, -1)),
                (__props.homeOwnerAddress)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: 'https://www.google.com/maps?q=' + __props.homeOwnerAddress,
                      target: "_blank",
                      class: "text-base leading-[20px] tracking-[0.01rem] text-primary-text-color font-norma"
                    }, _toDisplayString(__props.homeOwnerAddress), 9, _hoisted_35))
                  : (_openBlock(), _createElementBlock("span", _hoisted_36, "-"))
              ])
            ]))
      ])
    ])
  ], 64))
}
}

})